import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpError } from '@rd/types';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { PromocodeApiService } from '../../services/promocode-api.service';
import {
  ValidatePromocodeData,
  ValidatePromocodeDataFail,
  ValidatePromocodeDataSuccess,
} from '../actions/promocode.actions';

@Injectable()
export class PromocodeEffects {
  private actions$ = inject(Actions);
  private promocodeApiService = inject(PromocodeApiService);

  validatePromocodeData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ValidatePromocodeData),
      switchMap(({ promocodeData }) =>
        this.promocodeApiService.validatePromocode(promocodeData).pipe(
          map((response) => ValidatePromocodeDataSuccess(response)),
          catchError((error: HttpError) =>
            of(ValidatePromocodeDataFail({ error })),
          ),
        ),
      ),
    ),
  );
}
